/* Vintage&Chic: botón "+" para cargar más productos en las colecciones y en la búsqueda, sin app */
(function () {
  function findGrid(root) {
    if (!root) return null;
    var grids = root.querySelectorAll('.grid.grid--uniform');
    for (var i = 0; i < grids.length; i++) {
      if (!grids[i].closest('.collection-filter')) return grids[i];
    }
    return null;
  }

  function init() {
    var wrap = document.querySelector('[data-vc-load-more]');
    if (!wrap) return;
    var btn = wrap.querySelector('button');
    var content = document.getElementById('CollectionAjaxContent');
    var grid = findGrid(content);
    if (!btn || !grid) return;

    var pag = content.querySelector('.pagination') || (content.parentNode && content.parentNode.querySelector('.pagination'));
    if (pag) pag.style.display = 'none';
    wrap.hidden = false;

    var label = btn.innerHTML;
    var loading = false;

    btn.addEventListener('click', function () {
      if (loading) return;
      var url = btn.getAttribute('data-next-url');
      if (!url) return;
      loading = true;
      btn.disabled = true;
      btn.innerHTML = '&hellip;';

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = findGrid(doc.getElementById('CollectionAjaxContent'));
          if (!newGrid) throw new Error('grid not found');

          var items = newGrid.querySelectorAll(':scope > .grid-product, :scope > .grid-search');
          Array.prototype.forEach.call(items, function (item) {
            var node = document.importNode(item, true);
            node.classList.add('aos-init', 'aos-animate');
            Array.prototype.forEach.call(node.querySelectorAll('[data-aos]'), function (el) {
              el.classList.add('aos-init', 'aos-animate');
            });
            grid.appendChild(node);
          });

          var nextBtn = doc.querySelector('[data-vc-load-more] button');
          var next = nextBtn && nextBtn.getAttribute('data-next-url');
          if (next) {
            btn.setAttribute('data-next-url', next);
            btn.innerHTML = label;
            btn.disabled = false;
            loading = false;
          } else {
            wrap.parentNode.removeChild(wrap);
          }
        })
        .catch(function () {
          window.location.href = url;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
